import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.timer = window.setTimeout(() => window.Turbo.visit(window.location.href, { action: "replace" }), 3000)
  }

  disconnect() {
    window.clearTimeout(this.timer)
  }
}
